module.exports = __webpack_public_path__ + "img/4-8-rusher.8f3c1c20.jpg";